import { render } from "./edit-client-pj.vue?vue&type=template&id=3dd0f6ce"
import script from "./edit-client-pj.vue?vue&type=script&lang=js"
export * from "./edit-client-pj.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__